<template>
    <div :class="wrapClasses">
        <div v-if="showUpDown" :class="handlerClasses">
            <a
                @click="up"
                :class="upClasses">
                <span :class="innerUpClasses" @click="preventDefault"></span>
            </a>
            <a
                @click="down"
                :class="downClasses">
                <span :class="innerDownClasses" @click="preventDefault"></span>
            </a>
        </div>
        <div :class="inputWrapClasses">
            <input
                ref="reference"
                :id="elementId"
                :class="inputClasses"
                :disabled="disabled"
                autocomplete="off"
                spellcheck="false"
                :autofocus="autofocus"
                @focus="focus"
                @blur="blur"
                @keydown.stop="keyDown"
                @input="change"
                @change="change"
                @mouseup="preventDefault"
                :readonly="readonly || !editable"
                :name="name"
                :value="formatterValue"
                :placeholder="placeholder">
        </div>
    </div>
</template>
<script>
import { oneOf, findComponentUpward } from "@/utils/assist";
import Emitter from "@/utils/component/emitter";

const prefixCls = "ivu-input-number";
const iconPrefixCls = "ivu-icon";

function addNum(num1, num2) {
  let sq1, sq2, m;
  try {
    sq1 = num1.toString().split(".")[1].length;
  } catch (e) {
    sq1 = 0;
  }
  try {
    sq2 = num2.toString().split(".")[1].length;
  } catch (e) {
    sq2 = 0;
  }
  //        if (sq1 === 0 || sq2 === 0) {
  //            return num1 + num2;
  //        } else {
  //            m = Math.pow(10, Math.max(sq1, sq2));
  //            return (num1 * m + num2 * m) / m;
  //        }
  m = Math.pow(10, Math.max(sq1, sq2));
  return (Math.round(num1 * m) + Math.round(num2 * m)) / m;
}

export default {
  name: "InputNumber",
  mixins: [Emitter],
  props: {
    max: {
      type: [Number, String],
      default: Infinity
    },
    min: {
      type: [Number, String],
      default: 0
    },
    step: {
      type: Number,
      default: 1
    },
    activeChange: {
      type: Boolean,
      default: false
    },
    showUpDown: {
      type: Boolean,
      default: true
    },
    isNumber: {
      type: Boolean,
      default: false
    },
    value: {
      type: [Number, String]
      // default: 1
    },
    size: {
      validator(value) {
        return oneOf(value, ["small", "large", "default"]);
      },
      default() {
        return !this.$IVIEW || this.$IVIEW.size === ""
          ? "default"
          : this.$IVIEW.size;
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    editable: {
      type: Boolean,
      default: true
    },
    //是否为有理数
    isRationalNumber: {
      type: Boolean,
      default: true
    },
    name: {
      type: String
    },
    precision: {
      type: [Number, String]
    },
    elementId: {
      type: String
    },
    formatter: {
      type: Function
    },
    parser: {
      type: Function
    },
    placeholder: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      focused: false,
      upDisabled: false,
      downDisabled: false,
      currentValue: this.value
    };
  },
  computed: {
    wrapClasses() {
      return [
        `${prefixCls}`,
        {
          [`${prefixCls}-${this.size}`]: !!this.size,
          [`${prefixCls}-disabled`]: this.disabled,
          [`${prefixCls}-focused`]: this.focused
        }
      ];
    },
    handlerClasses() {
      return `${prefixCls}-handler-wrap`;
    },
    upClasses() {
      return [
        `${prefixCls}-handler`,
        `${prefixCls}-handler-up`,
        {
          [`${prefixCls}-handler-up-disabled`]: this.upDisabled
        }
      ];
    },
    innerUpClasses() {
      return `${prefixCls}-handler-up-inner ${iconPrefixCls} ${iconPrefixCls}-ios-arrow-up`;
    },
    downClasses() {
      return [
        `${prefixCls}-handler`,
        `${prefixCls}-handler-down`,
        {
          [`${prefixCls}-handler-down-disabled`]: this.downDisabled
        }
      ];
    },
    innerDownClasses() {
      return `${prefixCls}-handler-down-inner ${iconPrefixCls} ${iconPrefixCls}-ios-arrow-down`;
    },
    inputWrapClasses() {
      return `${prefixCls}-input-wrap`;
    },
    inputClasses() {
      return `${prefixCls}-input`;
    },
    precisionValue() {
      // can not display 1.0
      let data = this.currentValue ? this.currentValue : this.min!==undefined?this.min : "0";
      if(data===null||data==='')return data
      if (!this.currentValue) {
        data = this.min!==undefined?this.min : "0";
        data = this.precision
          ? this.$utils.edit.fixed(data, this.precision,true)
          : data;
      } else {
        data = this.precision
          ? this.$utils.edit.fixed(data, this.precision)
          : this.currentValue;
      }

      data = data + "";
      //去掉头部多余的0
      data = data.replace(/^0+([0-9])/, "$1");
      //编辑时去掉末尾多余的0
      if(this.focused)data = data.replace(/(?:\.0*|(\.\d+?)0+)$/, "$1");
      return data;
    },
    formatterValue() {
      if (this.formatter && (this.precisionValue !== null || this.precisionValue !== '')) {
        return this.formatter(this.precisionValue);
      } else {
        return this.precisionValue;
      }
    }
  },
  methods: {
    preventDefault(e) {
      e.preventDefault();
    },
    up(e) {
      const targetVal = Number(e.target.value);
      if (this.upDisabled && isNaN(targetVal)) {
        return false;
      }
      this.changeStep("up", e);
    },
    down(e) {
      const targetVal = Number(e.target.value);
      if (this.downDisabled && isNaN(targetVal)) {
        return false;
      }
      this.changeStep("down", e);
    },
    changeStep(type, e) {
      if (this.disabled || this.readonly) {
        return false;
      }

      const targetVal = e.target.value;
      let val = this.currentValue;
      const step = Number(this.step);
      if (!this.$utils.isNumber(val)) {
        return false;
      }

      // input a number, and key up or down
      if (this.$utils.isNumber(targetVal)) {
        if (type === "up") {
          if (addNum(targetVal, step) <= this.max) {
            val = targetVal;
          } else {
            return false;
          }
        } else if (type === "down") {
          if (addNum(targetVal, -step) >= this.min) {
            val = targetVal;
          } else {
            return false;
          }
        }
      }

      if (type === "up") {
        val = addNum(val, step);
      } else if (type === "down") {
        val = addNum(val, -step);
      }
      this.setValue(val);
    },
    setValue(val) {
      const { min, max } = this;
      if (val !== ''&& this.$utils.isNumber(val)) {
        if (this.$utils.ratio(val,max)) {
          val = max;
        } else if (this.$utils.ratio(min,val)) {
          val = min;
        }
      }else{
        val=this.min!==undefined?this.min : "0"
      }
      // 如果 step 是小数，且没有设置 precision，是有问题的
      if (val!==''&&val!='null' && this.precision){
        val = this.$utils.edit.fixed(val, this.precision);
      }
      if (this.isNumber) {
        val = Number(val);
      }
      if(this.isRationalNumber){
        //编辑后去掉头部多余的0
        val = (val+'').replace(/^0+([0-9])/, "$1");
      }
      //change事件返回的数据补零
      let changeVal=val;
      if (val!==''&&val!='null' && this.precision) {
        changeVal = this.$utils.edit.fixed(val, this.precision, true);
      }
      this.$nextTick(() => {
        this.currentValue = val;
        this.$emit("input", val);
        this.$emit("on-change", changeVal);
        this.dispatch("FormItem", "on-form-change", val);
      });
      return val
    },
    setfocus() {
      this.$refs.reference.focus();
    },
    focus(event) {
      this.focused = true;
      this.$emit("on-focus", event);
    },
    blur() {
        //刚刚进来的时候可能currentValue没值
      let val = this.currentValue||(this.min!==undefined?this.min : "0");
      val=val+''
      if (val!==''&&val!='null'&& this.precision) {
        val = this.$utils.edit.fixed(val, this.precision, true);
      }
      this.focused = false;
      //去掉头部多余的0
      val = val.replace(/^0+([0-9])/, "$1");
      this.currentValue=val;
      if (this.isNumber) {
        val = Number(val);
      }
      this.$nextTick(() => {
        this.$emit("input", val);
        this.$emit("on-blur", val);
      })
      if (
        !findComponentUpward(this, [
          "DatePicker",
          "TimePicker",
          "Cascader",
          "Search"
        ])
      ) {
        this.dispatch("FormItem", "on-form-blur", this.currentValue);
      }
    },
    keyDown(e) {
      if (e.keyCode === 38) {
        e.preventDefault();
        this.up(e);
      } else if (e.keyCode === 40) {
        e.preventDefault();
        this.down(e);
      }
    },
    change(event) {
      //保证触发change事件的只有一次
      if (event.type == "input" && !this.activeChange) return;
      if (event.type == "change" && this.activeChange) return;
      let val = event.target.value.trim();
      if (this.parser) {
        val = this.parser(val);
      }
      /* 先注释掉,为空也不传null 20181205
      const isEmptyString = val.length === 0;
      if (isEmptyString) {
        this.setValue(null);
        return;
      }*/
      if (event.type == "input" && val.match(/^\-?\.?$|\.$/)) return; // prevent fire early if decimal. If no more input the change event will fire later
      this.currentValue = this.setValue(val);
      event.target.value = this.currentValue;
    },
    changeVal(val) {
      if (this.$utils.isNumber(val)) {
        const step = this.step;
        this.upDisabled = this.$utils.ratio(this.$utils.add(val,step),this.max);
        this.downDisabled = this.$utils.ratio(this.min,this.$utils.sub(val,step));
      } else {
        this.upDisabled = true;
        this.downDisabled = true;
      }
    }
  },
  mounted() {
    this.changeVal(this.currentValue);
  },
  watch: {
    value(val) {
      this.currentValue = val;
    },
    currentValue(val) {
      this.changeVal(val);
    },
    min() {
      this.changeVal(this.currentValue);
    },
    max() {
      this.changeVal(this.currentValue);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/common/inumber/number.vue